import { Validator } from '@vista-digital/validator';
import { formAssetsValidator } from '../../../../subcomponents/form/form/types/assets';
import { formEventsValidator } from '../../../../subcomponents/form/form/types/events';
import { reactChildrenValidator } from '../../../../validators/react-children';
import { defaultUpdateMemberPasswordFormConfig, updateMemberPasswordFormConfigValidator } from './config';
import { defaultUpdateMemberPasswordFormDisplayText, updateMemberPasswordFormDisplayTextValidator } from './display-text';
export const defaultUpdateMemberPasswordFormProps = {
    assets: {},
    config: defaultUpdateMemberPasswordFormConfig,
    displayText: defaultUpdateMemberPasswordFormDisplayText,
    events: {},
    children: undefined
};
export const updateMemberPasswordFormPropsValidator = Validator.object({
    formId: Validator.optional(Validator.nonEmptyString),
    assets: formAssetsValidator,
    config: updateMemberPasswordFormConfigValidator,
    displayText: updateMemberPasswordFormDisplayTextValidator,
    events: formEventsValidator,
    children: reactChildrenValidator
});
//# sourceMappingURL=props.js.map